var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "writer",
      style: _vm.composerStyle,
    },
    [
      _c("studip-icon", {
        attrs: {
          shape: "blubber",
          size: 30,
          role: "info",
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "sr-only",
          attrs: {
            for: "blubber-placeholder",
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.placeholder ||
                  _vm.$gettext("Schreib was, frag was. Enter zum Abschicken.")
              ) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localText,
            expression: "localText",
          },
        ],
        ref: "textarea",
        attrs: {
          placeholder:
            _vm.placeholder ||
            _vm.$gettext("Schreib was, frag was. Enter zum Abschicken."),
          id: "blubber-placeholder",
        },
        domProps: {
          value: _vm.localText,
        },
        on: {
          change: _vm.saveCommentToSession,
          focus: _vm.resizeTextarea,
          keydown: function keydown($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            if (
              $event.ctrlKey ||
              $event.shiftKey ||
              $event.altKey ||
              $event.metaKey
            )
              return null
            return _vm.submit.apply(null, arguments)
          },
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              )
                return null
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              )
                return null
              return _vm.editPreviousComment.apply(null, arguments)
            },
            _vm.saveCommentToSession,
          ],
          input: function input($event) {
            if ($event.target.composing) return
            _vm.localText = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "send",
          attrs: {
            title: _vm.$gettext("Abschicken"),
          },
          on: {
            click: _vm.submit,
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: "arr_2up",
              size: 30,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "label",
        {
          ref: "label",
          staticClass: "upload",
          attrs: {
            title: _vm.$gettext("Datei hochladen"),
            tabindex: "0",
          },
          on: {
            keydown: _vm.simulateClick,
          },
        },
        [
          _c("input", {
            staticStyle: {
              display: "none",
            },
            attrs: {
              type: "file",
              multiple: "",
            },
            on: {
              change: _vm.onFilesPick,
            },
          }),
          _vm._v(" "),
          _c("studip-icon", {
            attrs: {
              shape: "upload",
              size: 30,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }